import { RenderableGroup } from './renderable-group';

/*
 * This is a group that contains 'cards'
 * if will render as a tabbed navigation
 */
export class RenderableCardGroup extends RenderableGroup {
}
